import { FilterPaneState } from '@blisspointmedia/bpm-types/dist/FilterPane';
import { FilterPreset } from '@blisspointmedia/bpm-types/dist/pgTables/FilterPreset';

export const getFilterNameError = (name: string | undefined): string | undefined =>
  !name || name.trim().length < 1 || name.trim().toLowerCase() === 'none'
    ? 'Must provide a valid filter name'
    : undefined;

interface BuildSavePresetFilterParams {
  selectedFilter: FilterPreset | undefined;
  saveAsNew: boolean;
  company: string | undefined;
  state: FilterPaneState;
  newFilterName: string | undefined;
}

export const buildSavePresetFilter = ({
  selectedFilter,
  saveAsNew,
  company,
  state,
  newFilterName
}: BuildSavePresetFilterParams): Partial<FilterPreset> =>
  selectedFilter && !saveAsNew
    ? {
        ...selectedFilter,
        filter_state: state,
        filter_tokens: [],
        isAdvanced: state.isAdvanced
      }
    : {
        company,
        filter_state: state,
        filter_tokens: [],
        isAdvanced: state.isAdvanced,
        name: newFilterName
      };
